import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 32;

export const migration_31_32:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'Chart' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((propSnapshot:any) =>
                            {
                                if( propSnapshot.name === 'chart' )
                                {
                                    setAxesTicksFontValue(propSnapshot._value);
                                    setAxesTicksFontBindPaths(propSnapshot._bindGroups, designState.bindings);
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function setAxesTicksFontValue(value:any)
{
    const fontValue = {
        'typeface': {
            '__type': 'STRINGENUM',
            'selectedValue': 'Helvetica Neue',
            'values': [
                'Arial',
                'Verdana',
                'Times New Roman',
                'Helvetica Neue'
            ]
        },
        'weight': {
            '__type': 'STRINGENUM',
            'selectedValue': 'Regular',
            'values': [
                'Thin',
                'Light',
                'Regular',
                'Medium',
                'Bold'
            ]
        },
        'color': {
            'hex': {
                '__type': 'STRING',
                'value': '#666666'
            },
            'alpha': {
                '__type': 'NUMBER',
                'value': 1
            }
        },
        'size': {
            'value': {
                '__type': 'NUMBER',
                'value': 12
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'lineHeight': {
            'value': {
                '__type': 'NUMBER',
                'value': 1
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'character': {
            'value': {
                '__type': 'NUMBER',
                'value': 1
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'fontStyle': {
            '__type': 'BOOLEAN',
            'value': false
        },
        'decorationUnderline': {
            '__type': 'BOOLEAN',
            'value': false
        },
        'decorationCrossed': {
            '__type': 'BOOLEAN',
            'value': false
        }
    };

    value.axes.xAxis.ticks.font = fontValue;
    value.axes.yAxis.ticks.font = fontValue;
}

function setAxesTicksFontBindPaths(bindGroups:any, bindings:any)
{
    const axesBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'axes');

    const axesPath:any = Object.values(axesBindGroup.rootBindItem.paths[0])
        .find((item:any) => item.path === 'axes');

    const xAxisPath:any = Object.values(axesPath.paths[0])
        .find((item:any) => item.path === 'xAxis');

    const xAxisTicksPath:any = Object.values(xAxisPath.paths[0])
        .find((item:any) => item.path === 'ticks');

    const yAxisPath:any = Object.values(axesPath.paths[0])
        .find((item:any) => item.path === 'yAxis');

    const yAxisTicksPath:any = Object.values(yAxisPath.paths[0])
        .find((item:any) => item.path === 'ticks');

    axesBindGroup.rootBindItem.paths[0][axesPath.id].paths[0][xAxisPath.id].paths[0][xAxisTicksPath.id].paths[0]['a64b9884-bc7e-4922-a7db-d2eae2811c2f'] = {
        'id': 'a64b9884-bc7e-4922-a7db-d2eae2811c2f',
        'path': 'font',
        'templatePath': 'axes.xAxis.ticks.font',
        'paths': [
            {
                'b686b336-d8c0-4da3-9757-e65a48fad6b3': {
                    'id': 'b686b336-d8c0-4da3-9757-e65a48fad6b3',
                    'path': 'typeface',
                    'templatePath': 'axes.xAxis.ticks.font.typeface',
                    'paths': null,
                    'bindingId': null
                },
                '3a535857-d196-489c-a5fc-a531263f9cf1': {
                    'id': '3a535857-d196-489c-a5fc-a531263f9cf1',
                    'path': 'weight',
                    'templatePath': 'axes.xAxis.ticks.font.weight',
                    'paths': null,
                    'bindingId': null
                },
                '34e1fbc2-34cb-4bee-b3b0-e3ecfb410b36': {
                    'id': '34e1fbc2-34cb-4bee-b3b0-e3ecfb410b36',
                    'path': 'fontStyle',
                    'templatePath': 'axes.xAxis.ticks.font.fontStyle',
                    'paths': null,
                    'bindingId': null
                },
                'e340f621-2906-41b4-affd-f096e47b96c3': {
                    'id': 'e340f621-2906-41b4-affd-f096e47b96c3',
                    'path': 'color',
                    'templatePath': 'axes.xAxis.ticks.font.color',
                    'paths': [
                        {
                            'aff03366-802b-40dd-ab5e-607f3bc8505d': {
                                'id': 'aff03366-802b-40dd-ab5e-607f3bc8505d',
                                'path': 'hex',
                                'templatePath': 'axes.xAxis.ticks.font.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            '547ed7eb-805a-41b7-93ef-7ae544ae5c7f': {
                                'id': '547ed7eb-805a-41b7-93ef-7ae544ae5c7f',
                                'path': 'alpha',
                                'templatePath': 'axes.xAxis.ticks.font.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '5085675b-ce58-4659-a1f5-d0e3bf051807': {
                    'id': '5085675b-ce58-4659-a1f5-d0e3bf051807',
                    'path': 'size',
                    'templatePath': 'axes.xAxis.ticks.font.size',
                    'paths': [
                        {
                            '7b43b513-215b-4eae-ba13-0a367d5b7993': {
                                'id': '7b43b513-215b-4eae-ba13-0a367d5b7993',
                                'path': 'unitsString',
                                'templatePath': 'axes.xAxis.ticks.font.size.unitsString',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '9dd966a9-2eaa-4600-aa18-d2df52b98286': {
                    'id': '9dd966a9-2eaa-4600-aa18-d2df52b98286',
                    'path': 'lineHeight',
                    'templatePath': 'axes.xAxis.ticks.font.lineHeight',
                    'paths': [
                        {
                            'b35c79ed-3d42-4b07-8000-9644a72236b1': {
                                'id': 'b35c79ed-3d42-4b07-8000-9644a72236b1',
                                'path': 'unitsString',
                                'templatePath': 'axes.xAxis.ticks.font.lineHeight.unitsString',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };

    axesBindGroup.rootBindItem.paths[0][axesPath.id].paths[0][yAxisPath.id].paths[0][yAxisTicksPath.id].paths[0]['2ac75ebc-7133-4a64-964c-9e9c008aac68'] = {
        'id': '2ac75ebc-7133-4a64-964c-9e9c008aac68',
        'path': 'font',
        'templatePath': 'axes.yAxis.ticks.font',
        'paths': [
            {
                '7980aa5d-735c-4e43-b4ba-f4eb94952868': {
                    'id': '7980aa5d-735c-4e43-b4ba-f4eb94952868',
                    'path': 'typeface',
                    'templatePath': 'axes.yAxis.ticks.font.typeface',
                    'paths': null,
                    'bindingId': null
                },
                'f737cb84-ef7c-44fa-aca2-e0dfe71e475c': {
                    'id': 'f737cb84-ef7c-44fa-aca2-e0dfe71e475c',
                    'path': 'weight',
                    'templatePath': 'axes.yAxis.ticks.font.weight',
                    'paths': null,
                    'bindingId': null
                },
                '342bde50-dda6-4a5d-8ff0-23f0f26d6865': {
                    'id': '342bde50-dda6-4a5d-8ff0-23f0f26d6865',
                    'path': 'fontStyle',
                    'templatePath': 'axes.yAxis.ticks.font.fontStyle',
                    'paths': null,
                    'bindingId': null
                },
                '3e7471b1-d5e0-4b0b-b3a0-a2e7ce2086c0': {
                    'id': '3e7471b1-d5e0-4b0b-b3a0-a2e7ce2086c0',
                    'path': 'color',
                    'templatePath': 'axes.yAxis.ticks.font.color',
                    'paths': [
                        {
                            '04f831df-89d6-4699-a4f4-7bb504b5530e': {
                                'id': '04f831df-89d6-4699-a4f4-7bb504b5530e',
                                'path': 'hex',
                                'templatePath': 'axes.yAxis.ticks.font.color.hex',
                                'paths': null,
                                'bindingId': null
                            },
                            'f5b46bc8-2513-41e8-9f1c-85724c38c1b9': {
                                'id': 'f5b46bc8-2513-41e8-9f1c-85724c38c1b9',
                                'path': 'alpha',
                                'templatePath': 'axes.yAxis.ticks.font.color.alpha',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                '57cbd975-a37a-416a-a14c-e3033b9e6ff9': {
                    'id': '57cbd975-a37a-416a-a14c-e3033b9e6ff9',
                    'path': 'size',
                    'templatePath': 'axes.yAxis.ticks.font.size',
                    'paths': [
                        {
                            '0f2236fd-d501-4673-ac81-ad201399bc28': {
                                'id': '0f2236fd-d501-4673-ac81-ad201399bc28',
                                'path': 'unitsString',
                                'templatePath': 'axes.yAxis.ticks.font.size.unitsString',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                },
                'da5183f3-2de3-4c5c-a893-e2d4fbf233f8': {
                    'id': 'da5183f3-2de3-4c5c-a893-e2d4fbf233f8',
                    'path': 'lineHeight',
                    'templatePath': 'axes.yAxis.ticks.font.lineHeight',
                    'paths': [
                        {
                            '535b3e29-ddd5-45e6-b25b-436402853e4d': {
                                'id': '535b3e29-ddd5-45e6-b25b-436402853e4d',
                                'path': 'unitsString',
                                'templatePath': 'axes.yAxis.ticks.font.lineHeight.unitsString',
                                'paths': null,
                                'bindingId': null
                            }
                        }
                    ],
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}
